import { render, staticRenderFns } from "./rightPublicTable.vue?vue&type=template&id=0453aede&scoped=true"
import script from "./rightPublicTable.vue?vue&type=script&lang=js"
export * from "./rightPublicTable.vue?vue&type=script&lang=js"
import style0 from "./rightPublicTable.vue?vue&type=style&index=0&id=0453aede&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0453aede",
  null
  
)

export default component.exports